import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "../../../components/private/pagination";

const Programas = () => {
  const { authFetch } = useContext(AuthContext);

  const [programas, setProgramas] = useState([]);
  const [areaUser, setAreaUser] = useState(null);
  const [areaName, setAreaName] = useState("");
  const [name, setName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true);
  const [role, setRole] = useState("");
  const [areas, setAreas] = useState([]);
  // FILTRO
  const [search, setSearch] = useState("");

  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;


  // ===============================
  // OBTENER AREA
  // ===============================
  const fetchAreas = useCallback(async () => {
    try {
      const data = await authFetch(ENDPOINTS.getarea);
      if (data.success) {
        setAreas(data.data || []);
      }
    } catch (error) {
      console.error("Error cargando áreas:", error);
    }
  }, [authFetch]);
  // ===============================
  // OBTENER USUARIO (SIN .json())
  // ===============================
const fetchUser = useCallback(async () => {
  try {
    const data = await authFetch(ENDPOINTS.me);

    if (data.success && data.user) {
      setAreaUser(data.user.area || null);
      setAreaName(data.user.area_namfronte || "");
      setRole(data.user.role); 
    }
  } catch (error) {
    console.error("Error obteniendo usuario:", error);
  } finally {
    setLoadingUser(false);
  }
}, [authFetch]);

  // ===============================
  // LISTAR PROGRAMAS (SIN .json())
  // ===============================
const fetchProgramas = useCallback(async () => {
  try {
    const data = await authFetch(ENDPOINTS.get_programasAll);

    if (data.success) {
      setProgramas(data.data || []);
    }
  } catch (error) {
    console.error("Error cargando programas:", error);
  }
}, [authFetch]);


useEffect(() => {
  const init = async () => {
    await fetchUser();
    await fetchProgramas();
  };

  init();
}, [fetchUser, fetchProgramas]);

// AREA
useEffect(() => {
  if (!loadingUser && role === "SuperAdmin") {
    fetchAreas();
  }
}, [loadingUser, role, fetchAreas]);


  // ===============================
  // FILTRO
  // ===============================

  const filteredProgramas = programas.filter((prog) => {

    const query = search.toLowerCase();

    return (
      prog.program_name?.toLowerCase().includes(query) ||
      prog.area_name?.toLowerCase().includes(query)
    );
  });

  // ===============================
  // PAGINACIÓN
  // ===============================

  const totalPages = Math.ceil(
    filteredProgramas.length / recordsPerPage
  );

  const currentPrograms = filteredProgramas.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  // ===============================
  // CREAR PROGRAMA
  // ===============================
  const handleCreateProgram = async (e) => {
    e.preventDefault();

    if (!areaUser) {
      alert("No tienes un área asignada.");
      return;
    }

    try {
      const data = await authFetch(ENDPOINTS.create_programas, {
        method: "POST",
        body: JSON.stringify({
          name,
          area: areaUser,
        }),
      });

      if (data.success) {
        setShowModal(false);
        setName("");
        fetchProgramas();
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Error creando programa:", error);
    }
  };

  return (
    <div className="container mt-4 p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Programas</h3>

        <button
          className="btn btn-outline-pink"
          onClick={() => setShowModal(true)}
          disabled={loadingUser}
        >
          Nuevo Programa
        </button>
      </div>

      <div className="row mb-3">

        <div className="col-md-4">

          <label className="m-1">
            Buscar programa o área
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Buscar..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />

        </div>

      </div>

      <table className="table table-hover">
        <thead className="table-secondary">
          <tr>
            <th>ID</th>
            <th>Área</th>
            <th>Nombre</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          {currentPrograms.length > 0 ? (
            currentPrograms.map((prog) => (
              <tr key={prog.id}>
                <td>{prog.id}</td>
                <td>{prog.area_name}</td>
                <td>{prog.program_name}</td>
                <td>
                  {Number(prog.status) === 0 ? "Activo" : "Inactivo"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No hay programas disponibles
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
      />

      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleCreateProgram}>
                <div className="modal-header">
                  <h5 className="modal-title">Crear Programa</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Nombre</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Área</label>
                      {role === "SuperAdmin" ? (
                        <select
                          className="form-select"
                          value={areaUser || ""}
                          onChange={(e) => setAreaUser(Number(e.target.value))}
                        >
                          <option value="" hidden>Seleccione un área</option>
                          {areas.map((a) => (
                            <option key={a.id_area} value={a.id_area}>
                              {a.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          value={areaName || ""}
                          placeholder={loadingUser ? "Cargando..." : ""}
                          disabled
                        />
                      )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-purple"
                    onClick={() => setShowModal(false)}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-outline-pink">
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Programas;
